import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var self;
var now = new Date();
var nowMonth = now.getMonth();
var nowYear = now.getYear();
nowYear += nowYear < 2000 ? 1900 : 0;
var lastMonthDate = new Date();
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
var lastMonth = lastMonthDate.getMonth();
var getDateStr = function getDateStr(v) {
  var nowDate = new Date().getTime();
  var targetDate = new Date(nowDate);
  var dd = targetDate;
  dd.setDate(dd.getDate() + v);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();
  return "".concat(y, "-").concat(m, "-").concat(d);
};
var formatDate = function formatDate(date) {
  var myyear = date.getFullYear();
  var mymonth = date.getMonth() + 1;
  var myweekday = date.getDate();
  if (mymonth < 10) {
    mymonth = "0".concat(mymonth);
  }
  if (myweekday < 10) {
    myweekday = "0".concat(myweekday);
  }
  return "".concat(myyear, "-").concat(mymonth, "-").concat(myweekday);
};
var getMonthDays = function getMonthDays(myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1);
  var monthEndDate = new Date(nowYear, myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
};
var getMonthStartDate = function getMonthStartDate() {
  var monthStartDate = new Date(nowYear, nowMonth, 1);
  return formatDate(monthStartDate);
};
var getMonthEndDate = function getMonthEndDate() {
  var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
  return formatDate(monthEndDate);
};
var getLastMonthStartDate = function getLastMonthStartDate() {
  var lastMonthStartDate = null;
  if (lastMonth === 11) {
    lastMonthStartDate = new Date(nowYear - 1, lastMonth, 1);
  } else {
    lastMonthStartDate = new Date(nowYear, lastMonth, 1);
  }
  return formatDate(lastMonthStartDate);
};
var getLastMonthEndDate = function getLastMonthEndDate() {
  var lastMonthEndDate = null;
  if (lastMonth === 11) {
    lastMonthEndDate = new Date(nowYear - 1, lastMonth, getMonthDays(lastMonth));
  } else {
    lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
  }
  return formatDate(lastMonthEndDate);
};
export default {
  props: {
    clear: {
      default: true,
      type: Boolean
    },
    isShowHeader: {
      default: false,
      type: Boolean
    },
    defaultValue: Array,
    // 该处待修改-无bug，只是有点不符预期
    dateType: {
      default: 'datetimerange',
      type: String
    },
    defaultTime: {
      type: Array,
      default: function _default() {
        return ['00:00:00', '23:59:59'];
      }
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    chooseRange: {
      type: [String, Number],
      default: 30
    }
  },
  watch: {
    defaultValue: {
      handler: function handler(v) {
        if (v) this.result = v;
      },
      immediate: true,
      deep: true
    },
    clear: function clear(v) {
      if (v) this.result = null;
    },
    result: function result(v) {
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.$emit('input', [start, end]);
      } else {
        this.$emit('input', v);
      }
    }
  },
  computed: {
    pickerOptions: function pickerOptions() {
      return {
        shortcuts: [{
          text: this.$t('720'),
          onClick: function onClick(picker) {
            var today = getDateStr(0);
            var start = new Date(new Date(today).setHours(0, 0, 0, 0));
            var end = new Date(new Date(today).setHours(23, 59, 59, 59));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('721'),
          onClick: function onClick(picker) {
            var yesterday = getDateStr(-1);
            var start = new Date(new Date(yesterday).setHours(0, 0, 0, 0));
            var end = new Date(new Date(yesterday).setHours(23, 59, 59, 59));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('722'),
          onClick: function onClick(picker) {
            var beforeYesterday = getDateStr(-2);
            var start = new Date(new Date(beforeYesterday).setHours(0, 0, 0, 0));
            var end = new Date(new Date(beforeYesterday).setHours(23, 59, 59, 59));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('723'),
          onClick: function onClick(picker) {
            picker.$emit('pick', [new Date(new Date(getDateStr(-7)).setHours(0, 0, 0, 0)), new Date(new Date(getDateStr(0)).setHours(23, 59, 59, 59))]);
          }
        }, {
          text: this.$t('724'),
          onClick: function onClick(picker) {
            var startMouth = getMonthStartDate();
            var endMouth = getMonthEndDate();
            var start = new Date(new Date(startMouth).setHours(0, 0, 0, 0));
            var end = new Date(new Date(endMouth).setHours(23, 59, 59, 59));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('725'),
          onClick: function onClick(picker) {
            var lastStartMouth = getLastMonthStartDate();
            var lastEndMouth = getLastMonthEndDate();
            var start = new Date(new Date(lastStartMouth).setHours(0, 0, 0, 0));
            var end = new Date(new Date(lastEndMouth).setHours(23, 59, 59, 59));
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate: function disabledDate(time) {
          var daySeconds = 86400000;
          var curSelectTime = new Date(self.minDate).getTime();
          var before = curSelectTime - daySeconds * Number(self.chooseRange);
          // after 时间戳导致，不能都已0点起算，否则会导致可选范围内最后一天不可选择
          var after = curSelectTime + 86399999 + daySeconds * Number(self.chooseRange);
          return time.getTime() > after || time.getTime() < before;
        },
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          if (!maxDate) {
            self.minDate = minDate;
          }
        }
      };
    }
  },
  created: function created() {
    self = this;
  },
  data: function data() {
    return {
      result: '',
      minDate: ''
    };
  }
};